const LEADERBOARD_ACCESS_KEY = 'mr_leaderboard_access';
const LEADERBOARD_ACCESS_TTL_MS = 1000 * 60 * 60 * 8; // 8 hours

const normalizeCode = (code) => (code || '').trim().toLowerCase();

export const grantLeaderboardAccess = (accessCode) => {
  const payload = {
    accessCode: normalizeCode(accessCode),
    grantedAt: Date.now(),
    expiresAt: Date.now() + LEADERBOARD_ACCESS_TTL_MS,
  };
  sessionStorage.setItem(LEADERBOARD_ACCESS_KEY, JSON.stringify(payload));
};

export const hasLeaderboardAccess = (expectedCode) => {
  const normalizedExpectedCode = normalizeCode(expectedCode);

  try {
    const raw = sessionStorage.getItem(LEADERBOARD_ACCESS_KEY);
    if (!raw) return false;

    const parsed = JSON.parse(raw);
    const hasValidExpiry = parsed?.expiresAt ? Date.now() < parsed.expiresAt : true;
    const hasExpectedCode = parsed?.accessCode
      ? normalizeCode(parsed.accessCode) === normalizedExpectedCode
      : true;

    return hasValidExpiry && hasExpectedCode;
  } catch {
    // Backward compatibility: support legacy plain-string value
    const raw = sessionStorage.getItem(LEADERBOARD_ACCESS_KEY);
    return normalizeCode(raw) === normalizedExpectedCode;
  }
};

export const clearLeaderboardAccess = () => {
  sessionStorage.removeItem(LEADERBOARD_ACCESS_KEY);
};
